import React from "react";
import type { RouteObject } from "react-router-dom";

const TemplatesPage = React.lazy(() => import("./TemplatesPage"));

// PENDING: PENDING-NAV-ROUTES. Sample page: no backend.
export const buildTemplatesRoutes = (): RouteObject[] => [{ path: "/templates", element: <TemplatesPage /> }];
